<template>
    <div
        v-if="enabled"
        ref="root"
        class="patsnap-copilot"
    >
        <WujieVue v-bind="getOptions()" />
    </div>
</template>

<script setup lang="ts">
import WujieVue from 'wujie-vue2';
import {
    nextTick, onBeforeUnmount, ref, withDefaults, defineProps, watch,
} from 'vue';
import type { PatsnapCopilotService } from 'src/patsnap-copilot-service.interface';
import { wujieOptions } from '../copilot';
import { useCopilotUsage } from './composables/use-copilot-usage';

const { enabled, patsnapCopilotUsage } = useCopilotUsage();

const props = withDefaults(defineProps<{
    service?: PatsnapCopilotService;
    url: string;
}>(), {
    service: undefined,
});

function getOptions() {
    const options = wujieOptions({
        service: props.service,
        url: props.url,
        patsnapCopilotUsage: patsnapCopilotUsage.value,
    });
    return options;
}

const root = ref<HTMLElement | null>(null);

watch(enabled, async (value) => {
    if (value) {
        await nextTick();
        if (root.value) {
            document.body.appendChild(root.value);
        }
    } else {
        await nextTick();
        if (root.value) {
            document.body.removeChild(root.value);
        }
    }
});

onBeforeUnmount(() => {
    if (root.value) {
        document.body.removeChild(root.value);
    }
});
</script>

<style lang="scss">
.patsnap-copilot {
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 1000;
}
</style>
